/* eslint-disable @angular-eslint/directive-selector */

import { AfterViewInit, Directive, ElementRef, OnDestroy, inject, input } from '@angular/core';
import { SessionStore } from '../../core/state';

@Directive({ selector: '[inView]' })
export class CmgInViewDirective implements AfterViewInit, OnDestroy {
  private readonly _el = inject(ElementRef);
  private readonly _sessionStore = inject(SessionStore);

  readonly inView = input<number>(undefined);
  readonly scrollArea = input<HTMLElement>(undefined);

  private _intersectionObserver: IntersectionObserver;

  ngAfterViewInit() {
    // Need to set a timeout here so the sections have time to load,
    // otherwise the intersection observer gets the incorrect placement
    // on the page
    setTimeout(() => {
      // Setting rootMargin to '-49% -10% -49% -10%' in order to simulate a very narrow, horizontal
      // band across the scrollable area that determines when an element is predominantly in view
      const OPTIONS: IntersectionObserverInit = {
        root: this.scrollArea() ?? null,
        rootMargin: '-49% -10% -49% -10%',
        threshold: 0,
      };

      this._intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this._sessionStore.updateNavPosition(this.inView());
          }
        });
      }, OPTIONS);
      this._intersectionObserver.observe(this._el.nativeElement);
    }, 5000);
  }

  ngOnDestroy() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
    }
  }
}
